import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";
import { useEffect, useState } from "react";
import { useApiCall } from "../../component/custom-hooks/api-call";

const ConfigLayout = () => {
    const navList = useNav();
    let { configBottomNav, topConfigNav } = navList;

    const apiCall = useApiCall();
    const [dropdownData, setDropdownData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchDropdowns = async () => {
            setIsLoading(true);
            try {
                const res = await apiCall({ url: "get-dropdown-list", method: "get" });
                setDropdownData(res?.data || {});
            } catch (err) {
                console.warn(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchDropdowns();
    }, []);

    return (
        <div className="webBody">
            <Header bottomTabs={configBottomNav} topTabs={topConfigNav} />
            <Outlet context={{ dropdownData, isLoading }} />
        </div>
    );
};

export default ConfigLayout;
